import React, { useEffect, useState, useContext, useRef } from 'react'

import { DateRangePickerProps } from './DateRangePicker.types'
import useDate from '../useDate'
import InputWrapper from '../../InputWrapper/InputWrapper'
import WithPopup from '../../withPopup/withPopup'
import Cleave from 'cleave.js/react'
import DateInput from '../DateInput'
import useInput from '../../useInput'
import MonthInput from '../DateInputElements/MonthInput'
import YearInput from '../DateInputElements/YearInput'
import DayInput from '../DateInputElements/DayInput'
import DateCalendar from '../DateInputElements/DateCalendar'
import { Button } from '../../../../index'
import DateHelpers from '../DateInputElements/DateHelpers'
import Icon from '../../../Icon/Icon'
// const Wrapped = (props) => {
//     return <InputWrapper {...props}>{(ctx) => <DateRangePicker {...props} />}</InputWrapper>
// }

const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
    const {
        helpers = [],
        delimiter = '/',
        format = 'MM/DD/YYYY',
        depth = 'day',
        showCalendar = false,
        min,
        max,
    } = props
    const context = useInput(props, 'date', { start: null, end: null })
    const { value, onChange, onFocus, onBlur } = context
    const containerRef = useRef(null)
    const [showCalendarPopup, setShowCalendarPopup] = useState(false)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    useEffect(() => {
        onChange({ start: startDate, end: endDate })
    }, [startDate, endDate])

    const {
        startDay,
        startMonth,
        startYear,
        setStartDay,
        setStartMonth,
        setStartYear,
        endDay,
        endMonth,
        endYear,
        setEndDay,
        setEndMonth,
        setEndYear,
        // viewStartYear,
        // viewStartMonth,
        // viewEndYear,
        // viewEndMonth,
        // setViewStartMonth,
        // setViewStartYear,
        // setViewEndMonth,
        // setViewEndYear,
        // handleDateSelect,
        isStartValid,
        isEndValid,
        isDirty,
    } = useDate({
        isRange: true,
        onChange,
        value,
        // format,
        depth,
        // helpers: [],
        min,
        max,
    })

    const focusNextInput = (index) => () => {
        setTimeout(() => {
            const nextInput = containerRef.current.querySelector('input[data-index="' + (index + 1) + '"]')
            if (nextInput) {
                nextInput.focus()
            }
        })
    }
    return (
        <InputWrapper {...context}>
            <WithPopup
                content={() => {
                    return (
                        <div className={'r-datepicker-wrapper r-daterangepicker-calendar-wrapper'}>
                            {helpers.length > 0 ? <DateHelpers updateDate={onChange} helpers={helpers} /> : ''}

                            {/*<DateCalendar*/}
                            {/*    isRange*/}
                            {/*    depth={depth}*/}
                            {/*    start={value.start}*/}
                            {/*    end={value.end}*/}
                            {/*    viewMonth={viewStartMonth}*/}
                            {/*    viewYear={viewStartYear}*/}
                            {/*    setViewMonth={setViewStartMonth}*/}
                            {/*    setViewYear={setViewStartYear}*/}
                            {/*    handleDateSelect={(date) => {*/}
                            {/*        handleDateSelect(date)*/}
                            {/*        // setShowCalendar(false)*/}
                            {/*    }}*/}
                            {/*/>*/}
                            {/*<DateCalendar*/}
                            {/*    isRange*/}
                            {/*    depth={depth}*/}
                            {/*    start={value.start}*/}
                            {/*    end={value.end}*/}
                            {/*    minViewMonth={viewStartMonth + 1}*/}
                            {/*    viewMonth={viewEndMonth}*/}
                            {/*    viewYear={viewEndYear}*/}
                            {/*    setViewMonth={setViewEndMonth}*/}
                            {/*    setViewYear={setViewEndYear}*/}
                            {/*    handleDateSelect={(date) => {*/}
                            {/*        handleDateSelect(date)*/}
                            {/*        // setShowCalendar(false)*/}
                            {/*    }}*/}
                            {/*/>*/}
                        </div>
                    )
                }}
                show={showCalendarPopup}
                onShow={() => {
                    onFocus()
                }}
                onClose={() => {
                    onBlur()
                    setShowCalendarPopup(false)
                }}
                width={'auto'}
                // height={'500px'}
                maxHeight={null}
            >
                {(popupContext) => {
                    return (
                        <div ref={popupContext.anchor} className={'r-input-base r-daterangepicker-container '}>
                            {isDirty ? (
                                <Icon
                                    style={{ display: 'flex', alignItems: 'center', marginRight: '8px' }}
                                    type={isStartValid && isEndValid ? 'check-circle' : 'exclamation-circle'}
                                    className={isStartValid && isEndValid ? 'r-color-green' : 'r-color-red'}
                                />
                            ) : null}
                            {/*<span className={'r-daterange-label'}>Start:</span>*/}
                            <DateInput
                                key={1}
                                date={startDate}
                                format={format}
                                depth={depth}
                                day={startDay}
                                month={startMonth}
                                year={startYear}
                                setDate={(v) => setStartDate(v)}
                                setDay={setStartDay}
                                setMonth={setStartMonth}
                                setYear={setStartYear}
                            />
                            <Icon style={{ opacity: 0.65, margin: 'auto 10px' }} type={'arrow-right'} />
                            {/*<span className={'r-daterange-label'} style={{ marginLeft: '12px' }}>*/}
                            {/*    {' '}*/}
                            {/*    End:*/}
                            {/*</span>*/}
                            <DateInput
                                key={2}
                                date={endDate}
                                format={format}
                                depth={depth}
                                day={endDay}
                                month={endMonth}
                                year={endYear}
                                setDate={(v) => setEndDate(v)}
                                setDay={setEndDay}
                                setMonth={(v) => {
                                    setEndMonth(v)
                                }}
                                setYear={setEndYear}
                            />
                            {showCalendar ? (
                                <Button
                                    style={{ margin: '0 0 0 4px' }}
                                    buttonStyle={{ padding: '1px 5px 3px 5px' }}
                                    size={'sm'}
                                    icon={'calendar-alt'}
                                    onClick={(e) => setShowCalendarPopup(true)}
                                />
                            ) : null}
                        </div>
                    )
                }}
            </WithPopup>
        </InputWrapper>
    )
}

export default DateRangePicker
